import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-remark",
  "use": "icon-remark-usage",
  "viewBox": "0 0 22 30",
  "content": "<symbol viewBox=\"0 0 22 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-remark\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.58421 0V8.59224C9.58421 10.6267 11.2327 12.2751 13.2671 12.2751H21.8594V27.8905C21.8594 28.8861 21.0441 29.7013 20.0486 29.7013H1.81079C0.815216 29.7013 0 28.8861 0 27.8905V1.81079C0 0.815217 0.815216 0 1.81079 0H9.58421ZM22 10.4337H13.6819C12.5997 10.4337 11.716 9.54633 11.716 8.46419V0.142484L22 10.4337Z\" fill=\"#2648FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol